<template lang="pug">
  .single-histogram(ref="SinglePieHistogramWrap")
</template>
<script>
// title: '出口温湿度',
// histogramName1: 'T',
// max:200,
// pieMax:100,
// sign:'°C'
export default {
  name: 'SinglePieHistogramWrap',
  props: {
    opts: {
      type: Object,
      required: true
    },
    series: {
      required: false
    }
  },
  computed: {
    options () {
      const SinglePieHistogramWrapDefault = {
        title: '出口温湿度',
        histogramName1: 'T',
        max: 50,
        pieMax: 100,
        sign: '°C'
      }
      const resu = Object.assign(SinglePieHistogramWrapDefault, this.opts)
      return resu
    }
  },
  watch: {
    series: {
      deep: true,
      handler (val) {
        if (val) {
          this.updateSerise(val)
        }
      }
    }
  },
  data () {
    return {
      graph: null
    }
  },
  mounted () {
    this.initGraph()
  },
  methods: {
    initGraph () {
      this.graph = this.$echarts.init(this.$refs.SinglePieHistogramWrap)
      this.graph.showLoading()
    },
    updateSerise (serise) {
      const that = this
      const _data1 = serise.data1 || '--'
      let _data2 = serise.data2 || '--'
      _data2 = serise.data2 > that.options.pieMax ? that.options.pieMax : serise.data2
      let option = {
        backgroundColor: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: 'rgba(255, 255, 255, 0.0)'
            },
            {
              offset: 1,
              color: 'rgba(255, 255, 255, 0.0)'
            }
          ]
        },
        color: ['#5c8cd3'],
        title: {
          text: that.options.title,
          left: '1%',
          top: '1%',
          textStyle: {
            lineHeight: 50,
            color: '#000',
            fontSize: 17,
            fontWeight: '400'
          }
        },
        tooltip: {
          show: true
        },
        label: {
          normal: {
            show: true,
            fontSize: 30,
            color: '#000',
            position: 'top'
          }
        },
        itemStyle: {
          normal: {
            color: '#5c8cd3',
            borderWidth: 3,
            opacity: 1
          },
          emphasis: {
            color: '#5c8cd3'
          }
        },
        grid: {
          left: '5%',
          right: '5%',
          top: '7%',
          bottom: '5%',
          containLabel: false
        },
        xAxis: {
          type: 'category',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#bcd6ed'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          boundaryGap: true,
          data: []
        },
        yAxis: {
          max: function (value) {
            if (value.max > that.options.max) {
              return value.max * 1.3
            }
            return that.options.max + value.max * 0.3
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          type: 'value'
        },
        series: [
          {
            name: that.options.histogramName1,
            smooth: true,
            barGap: '80%',
            z: 2,
            barWidth: '35%', // 柱图宽度
            type: 'bar',
            data: [200],
            itemStyle: {
              normal: {
                label: {
                  show: false,
                  position: 'top',
                  formatter: ['{a|{a}       }', '   {c}' + that.options.sign].join(
                    '\n'
                  ),
                  rich: {
                    a: {
                      color: '#000',
                      fontSize: that.options.toprichFontSize
                    }
                  },
                  textStyle: {
                    color: '#000',
                    fontSize: that.options.topFontSize,
                    lineHeight: 20
                  }
                }
              }
            }
          },
          {
            type: 'pie',
            center: that.options.center1,
            radius: that.options.radius1,
            hoverAnimation: false,
            itemStyle: {
              normal: {
                color: '#243d91',
                shadowBlur: 9,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
                shadowOffsetY: 12
              },
              emphasis: {
                color: '#243d91'
              }
            },
            label: {
              normal: {
                position: 'center',
                textStyle: {
                  textShadowColor: '#000',
                  textShadowBlur: 5
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            data: [
              {
                value: 40,
                name: that.options.pieName1,
                label: {
                  normal: {
                    position: 'center',
                    formatter: ['{a|{b}       }', '{d}%'].join('\n'),
                    rich: {
                      a: {
                        color: '#fff',
                        fontSize: 15,
                        fontWeight: 300
                      }
                    },
                    textStyle: {
                      color: '#fff',
                      fontSize: 25,
                      fontWeight: 300,
                      textShadowColor: '#2e4694',
                      textShadowBlur: 2,
                      textShadowOffsetY: 2
                    }
                  }
                }
              },
              {
                value: 60,
                name: '占位',
                tooltip: {
                  show: false
                },
                itemStyle: {
                  normal: {
                    color: '#a0b3d0'
                  },
                  emphasis: {
                    color: '#a0b3d0'
                  }
                },
                label: {
                  normal: {
                    position: 'left',
                    show: false
                  }
                }
              }
            ]
          },
          {
            name: '',
            barGap: '-100%',
            barWidth: '30%', // 柱图宽度
            type: 'bar',
            data: [100],
            z: 1,
            tooltip: {
              show: false,
            },
            itemStyle: {
              normal: {
                color: 'rgba(0,0,0,0)',
                label: {
                  show: true,
                  position: 'top',
                  formatter: ['{a|{a}       }', '   ' + _data1 + '' + that.options.sign].join(
                    '\n'
                  ),
                  rich: {
                    a: {
                      color: '#000',
                      fontSize: that.options.toprichFontSize
                    }
                  },
                  textStyle: {
                    color: '#000',
                    fontSize: that.options.topFontSize,
                    lineHeight: 20
                  }
                }
              }
            }
          }
        ]
      }
      option.series[0].data[0] = _data1
      option.series[1].data[0].value = _data2
      option.series[1].data[1].value = that.options.pieMax - _data2
      that.graph.hideLoading()
      that.graph.setOption(option)
      window.addEventListener('resize', function () {
        that.graph.resize()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.single-histogram {
  width: 100%;
  height: 100%;
}
</style>
